module.exports = __webpack_public_path__ + "img/操作手册_04.c9d071e6.svg";